import { render, staticRenderFns } from "./empresaSR.vue?vue&type=template&id=029baef4&"
import script from "./empresaSR.vue?vue&type=script&lang=js&"
export * from "./empresaSR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports